"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiddleTextTruncation = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const useOverflow_js_1 = require("../hooks/useOverflow.js");
const ELLIPSIS_CHAR = '…';
/**
 * Truncates text with the ellipsis in the middle,
 * leaving defined number of chars at the end.
 * @example
 * <MiddleTextTruncation text='ThisIsMyVeryLongFileName.dgn' />
 * @example
 * <MiddleTextTruncation text='ThisIsMyVeryLongFileName.dgn' endCharsCount={10} />
 * @example
 * <MiddleTextTruncation
 *   text='ThisIsMyVeryLongFileName.dgn'
 *   textRenderer={React.useCallback(
 *     (truncatedText) => <b>{truncatedText}</b>,
 *     []
 *   )}
 * />
 */
const MiddleTextTruncation = (props) => {
    var _a;
    const { text, endCharsCount = 6, textRenderer, style, ...rest } = props;
    const [ref, visibleCount] = (0, useOverflow_js_1.useOverflow)(text);
    const truncatedText = React.useMemo(() => {
        if (visibleCount < text.length) {
            return `${text.substring(0, visibleCount - endCharsCount - ELLIPSIS_CHAR.length)}${ELLIPSIS_CHAR}${text.substring(text.length - endCharsCount)}`;
        }
        else {
            return text;
        }
    }, [endCharsCount, text, visibleCount]);
    return (React.createElement("span", { style: {
            display: 'flex',
            minWidth: 0,
            flexGrow: 1,
            whiteSpace: 'nowrap',
            ...style,
        }, ref: ref, ...rest }, (_a = textRenderer === null || textRenderer === void 0 ? void 0 : textRenderer(truncatedText, text)) !== null && _a !== void 0 ? _a : truncatedText));
};
exports.MiddleTextTruncation = MiddleTextTruncation;
exports.default = exports.MiddleTextTruncation;
